import { createSelector } from 'reselect';
import getAuth from './getAuth';
import { type ReduxStateShared } from '~shared/types';

const getIsAuthorized: (state: ReduxStateShared) => boolean = createSelector(getAuth, (auth) => auth.authorized);

export default getIsAuthorized;
